// ==============================
// カウントダウン
// ==============================
const today = new Date();
const targetDate = new Date(today.getFullYear(), 2, 17); // 3月17日
const diffTime = targetDate.getTime() - today.getTime();

let remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
if (remainingDays < 0) remainingDays = 0;

const paddedDays = String(remainingDays).padStart(2, "0");
const countdownEl = document.querySelector(".js-countdown-date");

if (countdownEl) {
  countdownEl.textContent = paddedDays;
}